import { css } from 'aphrodite';
import * as React from 'react';
import { AccountDetailsInfoField } from '../../../components/accountDetails/AccountDetailsInfoField';
import { styleSheet } from './styles';

export const RenewalSummaryHeader: React.FC = () => {
	return (
		<div className={css(styleSheet.accountsHeader)}>
			<div className={css(styleSheet.accountHeaderName)}>Account</div>
			<div className={css(styleSheet.accountHeaderSmall)}>Renewal</div>
			<div className={css(styleSheet.accountHeaderSmall)}>Period</div>
			<AccountDetailsInfoField
				label='MRR'
				info='Accounts $300 and over shown in bold.'
				styles={[styleSheet.accountHeaderSmall, styleSheet.mrrColumn]}
			/>
			<div className={css(styleSheet.accountHeaderLarge)}>CSM</div>
			<div className={css(styleSheet.accountHeaderLarge)}>Probability</div>
			<div className={css(styleSheet.accountHeaderLarge)}>Discount %</div>
			<div className={css(styleSheet.accountHeaderSelect)}>Will Renew Prediction</div>
			<div className={css(styleSheet.accountHeaderSmall)}>Confirmed</div>
		</div>
	);
};
